import {
  LOGGED_IN_SIGNUP_STEPS_DE,
  LOGGED_IN_SIGNUP_STEPS_UK,
} from '../constants';

export function isLoggedInStep(step?: string) {
  return [...LOGGED_IN_SIGNUP_STEPS_UK, ...LOGGED_IN_SIGNUP_STEPS_DE].some(
    (allowedStep) => allowedStep === step,
  );
}
